import React from "react";
import FieldOverviewPage from "./FieldOverviewPage";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import { LoadingProvider } from "../LoadingSpinner/LoadingContext";
import useFields from "../../routes/customer/_customer_id/field/_field_id/useFields";

export default function FieldPage(): React.ReactNode {
  const [fieldIds] = useFields();

  const { fieldId, resultSetId: selectedResultSetId, customerId } = useParams();

  const parsedFieldId = fieldId ? toInt(fieldId) : undefined;
  const selectedFieldIds =
    fieldIds ?? (parsedFieldId ? [parsedFieldId] : undefined);

  const navigate = useNavigate();
  const location = useLocation();
  return (
    <LoadingProvider>
      <FieldOverviewPage
        selectedFieldIds={selectedFieldIds}
        selectedResultSetId={selectedResultSetId}
        onSelectResultSet={(resultSetId, fieldId, customerId, options) =>
          navigate(
            {
              pathname: resultSetId
                ? `/customer/${customerId}/field/${fieldId}/result-set/${resultSetId}`
                : `/customer/${customerId}/field/${fieldId}`,
              search: location.search,
            },
            options,
          )
        }
        onSelectField={(fieldId) =>
          navigate(`/customer/${customerId}/field/${fieldId}`)
        }
        onSelectMultipleFields={(fieldIds) => {
          if (fieldIds.length === 0) {
            navigate(`/customer/${customerId}/field`);
          } else if (fieldIds.length === 1) {
            navigate(`/customer/${customerId}/field/${fieldIds[0]}`);
          } else {
            navigate(
              `/customer/${customerId}/fields?fieldIds=${fieldIds.join(",")}`,
            );
          }
        }}
        onMergeTaskmaps={() => {
          navigate(`/customer/${customerId}/field`);
        }}
        onCreateTaskMap={(resultSetId: string, fieldId: number) =>
          navigate(
            `/customer/${customerId}/field/${fieldId}/taskmap/${resultSetId}`,
          )
        }
        onDownloadResult={(resultSetId: string) => {
          navigate(
            `/customer/${customerId}/field/${fieldId}/result-set/${resultSetId}/download`,
          );
        }}
      >
        <Outlet />
      </FieldOverviewPage>
    </LoadingProvider>
  );
}

export function toInt(input: string | undefined): number | undefined {
  const parsed = parseInt(input || "undefined", 10);
  return Number.isNaN(parsed) ? undefined : parsed;
}
